import React, { useEffect, useState } from "react";
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  CircularProgress, 
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow
} from "@mui/material";
import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

const DetailPlanView = ({ permitRequestNumber }) => {
  const [permitDetails, setPermitDetails] = useState([]);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch permit details from the API using the permitRequestNumber
    const fetchPermitDetails = async () => {
      try {
        setLoading(true); // Ensure loading is true before fetching
        const data = await GetDataFromApiWithParams(`buildingPermits/${permitRequestNumber}/details`); 
        console.log("API Response:", data);
        setPermitDetails(data);
      } catch (error) {
        console.error("Error fetching permit details:", error);
        setPermitDetails([]); // Set empty array on error
      } finally {
        setLoading(false); // Move setLoading here, after the API call completes
      }
    };
    
    fetchPermitDetails();
  }, [permitRequestNumber]);

  // Use useEffect to log state changes
  useEffect(() => {
    console.log("permitDetails state updated:", permitDetails);
  }, [permitDetails]);

  const handleSubmit = async () => {
    try {
      const responseData = await ExecuteApiToPost(`buildingPermits/${permitRequestNumber}/details`, {
        comment,
      });
      console.log(responseData);
      alert("Comment submitted successfully!");
      setComment(""); // Clear comment after successful submission
    } catch (error) {
      console.error("Error submitting comment:", error);
      alert("Failed to submit comment.");
    }
  };

  if (loading) {
    return (
      <Box p={3} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  // Add check for array length
  if (!permitDetails || permitDetails.length === 0) {
    return (
      <Box p={3}>
        <Typography variant="h6" color="error">
          No details found for permit request number {permitRequestNumber}.
        </Typography>
      </Box>
    );
  }

  // Since permitDetails is an array, access the first element
  const details = permitDetails[0] || {};

  return (
    <Box p={3}>
      <Typography 
        variant="body1" 
        gutterBottom
        sx={{ 
          color: 'black',
          fontWeight: 'normal',
          fontFamily: 'Arial, Helvetica, sans-serif',
          mb: 2,
          fontSize: '1.1rem'
        }}
      >
        Building Permit Request: {permitRequestNumber}
      </Typography>
      
      {console.log("OKAYOKAY", permitDetails)}
      
      {/* Permit Details Table */}
      <TableContainer component={Paper} sx={{ mb: 3, boxShadow: 2 }}>
        <Table size="small" aria-label="permit details table">
          <TableBody>
            <TableRow>
              <TableCell 
                component="th" 
                scope="row" 
                sx={{ 
                  fontWeight: 'bold', 
                  width: '200px', 
                  backgroundColor: '#f5f5f5',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Agreement ID
              </TableCell>
              <TableCell>{permitDetails.agreement_id || 'N/A'}</TableCell>
            </TableRow>
            
            <TableRow>
              <TableCell 
                component="th" 
                scope="row" 
                sx={{ 
                  fontWeight: 'bold', 
                  backgroundColor: '#f5f5f5',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Contractor Name
              </TableCell>
              <TableCell>{permitDetails.contractor_name || 'N/A'}</TableCell>
            </TableRow>
            
            <TableRow>
              <TableCell 
                component="th" 
                scope="row" 
                sx={{ 
                  fontWeight: 'bold', 
                  backgroundColor: '#f5f5f5',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Consultant Name
              </TableCell>
              <TableCell>{permitDetails.consultant_name || 'N/A'}</TableCell>
            </TableRow>
            
            <TableRow>
              <TableCell 
                component="th" 
                scope="row" 
                sx={{ 
                  fontWeight: 'bold', 
                  backgroundColor: '#f5f5f5',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Issue On
              </TableCell>
              <TableCell>{permitDetails.issued_on || 'N/A'}</TableCell>
            </TableRow>
            
            <TableRow>
              <TableCell 
                component="th" 
                scope="row" 
                sx={{ 
                  fontWeight: 'bold', 
                  backgroundColor: '#f5f5f5',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Request Type
              </TableCell>
              <TableCell>{permitDetails.request_type || 'N/A'}</TableCell>
            </TableRow>
            
            <TableRow>
              <TableCell 
                component="th" 
                scope="row" 
                sx={{ 
                  fontWeight: 'bold', 
                  backgroundColor: '#f5f5f5',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Requested On
              </TableCell>
              <TableCell>{permitDetails.requested_on || 'N/A'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

    </Box>
  );
};

export default DetailPlanView;